import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';

export default {
  extends: TablePage,
  props: {
    propsObj: Object,
  },
  components: {

  },
  data() {
    return {
      formFunctionCode: 'logs_list',
      params: { profileCode: this.propsObj.profileCode },
    };
  },
  async created() {
    console.log('thisfff', this.propsObj);
    this.getConfigList('logs_list');
  },
  methods: {
    modalClick({ val, row }) {

    },
  },
};
